import Vue from 'vue'

/**
 * @author Jose Luis R
 * Agree policy
 */

export default () =>
  Vue.$http.put(`/users/current/agree_policy/`)
    .then((res) => res.data)
